<script setup lang="ts">
defineProps<{
  open: boolean
  title: string
  body?: string
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
}>()

const emit = defineEmits<{ (e: 'confirm'): void; (e: 'cancel'): void }>()
</script>

<template>
  <div v-if="open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
    <div class="w-[420px] max-w-[90%] rounded-2xl bg-neutral-900 border border-neutral-700 p-6 flex flex-col gap-4 shadow-2xl">
      <h2 class="text-xl font-bold">{{ title }}</h2>
      <p v-if="body" class="text-neutral-300">{{ body }}</p>
      <div class="flex gap-3 justify-end mt-2">
        <button
          type="button"
          class="tap-target px-5 rounded-xl bg-neutral-700 hover:bg-neutral-600 font-semibold"
          @click="emit('cancel')"
        >
          {{ cancelLabel ?? 'Cancel' }}
        </button>
        <button
          type="button"
          class="tap-target px-5 rounded-xl font-semibold"
          :class="danger ? 'bg-red-600 hover:bg-red-500' : 'bg-emerald-600 hover:bg-emerald-500'"
          @click="emit('confirm')"
        >
          {{ confirmLabel ?? 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</template>
